<ion-button expand="block" (click)="showJournal()">
  {{ 'Mobile.Journal' | translate }}
</ion-button>
